const scrollElementIntoHorizontalView = (
  containerElement: HTMLElement | null,
  element: HTMLElement | null,
  offset = 16,
) => {
  if (!containerElement || !element) {
    return;
  }

  const elementLeftEdge = element.offsetLeft;
  const elementRightEdge = elementLeftEdge + element.offsetWidth;
  const viewportLeftEdge = containerElement.scrollLeft;
  const viewportRightEdge = viewportLeftEdge + containerElement.clientWidth;
  const maxScrollLeft = Math.max(0, containerElement.scrollWidth - containerElement.clientWidth);

  if (elementLeftEdge < viewportLeftEdge) {
    const targetLeft = Math.max(0, elementLeftEdge - offset);
    containerElement.scrollTo({ left: targetLeft, behavior: 'smooth' });
    return;
  }

  if (elementRightEdge > viewportRightEdge) {
    const targetLeft = Math.min(
      maxScrollLeft,
      elementRightEdge - containerElement.clientWidth + offset,
    );

    containerElement.scrollTo({ left: targetLeft, behavior: 'smooth' });
  }
};

export default scrollElementIntoHorizontalView;
